import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Check, Globe } from 'lucide-react';
import { REGIONS, useRegion } from '../context/RegionContext';

export default function RegionSelector() {
  const { region, setRegion } = useRegion();
  const [open, setOpen] = React.useState(false);
  const info = REGIONS.find((r) => r.code === region);

  const handleSelect = (code) => {
    setRegion(code);
    setTimeout(() => setOpen(false), 140);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          aria-label="Select region"
          data-testid="region-selector-trigger"
          className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-md hover:bg-gray-100 transition-colors"
        >
          {info ? (
            <span className="text-base leading-none">{info.flag}</span>
          ) : (
            <Globe className="w-4 h-4 text-gray-700" strokeWidth={2} />
          )}
          <span className="text-[13px] font-semibold text-gray-800">{info ? info.code : 'Region'}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        side="bottom"
        sideOffset={10}
        className="w-[340px] max-w-[92vw] p-0 rounded-xl border border-gray-200 shadow-[0_20px_50px_-10px_rgba(0,0,0,0.15)] bg-white"
      >
        <div className="px-5 pt-4 pb-3 border-b border-gray-100">
          <div className="text-[15px] font-medium text-gray-800">Select Region</div>
          <div className="text-[12px] text-gray-500">Sets suggested language and currency</div>
        </div>
        <div className="max-h-[320px] overflow-y-auto py-2">
          {REGIONS.map((r) => {
            const isSelected = region === r.code;
            return (
              <button
                key={r.code}
                onClick={() => handleSelect(r.code)}
                data-testid={`region-option-${r.code}`}
                className="w-full flex items-center gap-3 px-5 py-2.5 text-left hover:bg-gray-50 transition-colors"
              >
                <span className="text-xl leading-none w-7 text-center shrink-0">{r.flag}</span>
                <div className="flex-1 min-w-0">
                  <div className="text-[14px] font-semibold text-gray-900 truncate">{r.name}</div>
                  <div className="text-[11px] text-gray-500 uppercase tracking-wider">
                    {r.lang} · {r.currency}
                  </div>
                </div>
                {isSelected && <Check className="w-4 h-4 text-[#3b82f6] shrink-0" strokeWidth={3} />}
              </button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
}
